import TOAST_TYPES from "./constants";

// eslint-disable-next-line import/prefer-default-export
export function getIconFromType(type) {
  return TOAST_TYPES[type].icon;
}